module.exports = __webpack_public_path__ + "static/media/background.ec7c2d38.png";